import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  BrowserRouter,
  HashRouter,
  Navigate,
  Outlet,
  Routes,
  Route,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import ProfilePage from "../components/ProfilePage.jsx";
import ExsPage from "../components/ExsPage.jsx";
import ContactPage from "../components/ContactPage.jsx";
import InitialPage from "../components/InitialPage.jsx";
import Header from "../components/Header.jsx";
import Submenu from "../components/Submenu.jsx";
import ExerciseOptions from "../components/ExerciseOptions.jsx";
import ExMultipleabc from "../components/ExMultipleabc.jsx";
import ExDrag from "../components/ExDrag.jsx";
import ExAbc from "../components/ExAbc.jsx";
import ExPopups from "../components/ExPopups.jsx";
import Ex1popup from "../components/Ex1popup.jsx";
import { RegisterForm } from "../components/RegisterForm.jsx";
import { LoginForm } from "../components/LoginForm.jsx";
import PrivateRoute from "./PrivateRoute.jsx";
import IsloggedRoute from "./IsloggedRoute.jsx";
import { Error404 } from "../components/Error404.jsx";
import { Iframe } from "../components/Iframe.jsx";
import PdfViewer from "../components/PdfViewer.jsx";
import ExerciseCatsPage from "../components/ExerciseCatsPage.jsx";
import GenreCheckerDropdownPage from "../components/GenreCheckerDropdownPage.jsx";
import { ForgotForm } from "../components/ForgotForm.jsx";
import { SendForgotForm } from "../components/SendForgotForm.jsx";
import { globalT, shouldUseHashRouter } from "../utils/globalUtils.js";
import { AuthContext } from "../context/AuthContext.jsx";
import ArrowL from "../icons/arrowL.jsx";

export const AppRouter = ({ data }) => {
  const { setUserLog } = useContext(AuthContext);
  const [init, setInit] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [jsonData, setJsonData] = useState(null);
  const RouterComponent = shouldUseHashRouter() ? HashRouter : BrowserRouter;
  const isLocal = isLocalEnvironment();
  const localUser = useMemo(
    () => (isLocal ? getLocalDevUser() : null),
    [isLocal]
  );
  const privateRouteElement = isLocal ? <Outlet /> : <PrivateRoute />;
  const isLoggedRouteElement = isLocal ? (
    <Navigate to="/" replace />
  ) : (
    <IsloggedRoute />
  );
  // Generos textuales
  const [menu1Data, setMenu1Data] = useState([]);
  // Géneros textuales orientados a la industria turística
  const [menu2Data, setMenu2Data] = useState([]);

  useEffect(() => {
    if (!localUser) {
      return;
    }

    setUserLog(localUser);
  }, [localUser, setUserLog]);

  useEffect(() => {
    if (data) {
      setJsonData(data);
      const menu1 = data.filter((item) => item.menu === 1);
      const menu2 = data.filter((item) => item.menu === 2);
      setMenu1Data(menu1);
      setMenu2Data(menu2);
    }
  }, [data]);

  return (
    <RouterComponent>
      <Header />
      <div className="m-content" id="content">
        <div className="mdl-container">
          <ContentBackButton />
          <Routes>
            {/* Rutas de logeo, si esta logeado redirige a / */}
            <Route exact path="/login" element={isLoggedRouteElement}>
              <Route
                path="/login"
                element={<LoginForm init={init} setInit={setInit} />}
              />
            </Route>
            <Route exact path="/register" element={isLoggedRouteElement}>
              <Route
                path="/register"
                element={<RegisterForm init={init} setInit={setInit} />}
              />
            </Route>

            {/* Rutas privadas, si no esta logeado redirige a /login */}
            {jsonData &&
              menu1Data.map((el, i) => (
                <React.Fragment key={i}>
                  <Route
                    key={el.id}
                    path={`/exercices/excercie-${el.id}-options`}
                    element={getComponentElements("ExerciseOptions", el)}
                    init={init}
                    setInit={setInit}
                  />
                  <Route
                    key={el.id}
                    path={`/exercices/submenu${el.id}`}
                    element={getComponentElements("Submenu", el)}
                    init={init}
                    setInit={setInit}
                  />
                  {el.exercices.map((e, j) => (
                    <Route
                      key={`ex-${el.id}${j + 1}`}
                      path={`/exercices/submenu${el.id}/ex-${el.id}${j + 1}`}
                      element={getComponentElements(
                        "Ex" + e.type.charAt(0).toUpperCase() + e.type.slice(1),
                        e,
                        el.title
                      )}
                      init={init}
                      setInit={setInit}
                    />
                  ))}
                </React.Fragment>
              ))}
            {jsonData &&
              /* exercices/submenu y exercices/submenu se ha nde respetar */
              /* El primer componente route si se puede modificar */
              menu2Data.map((el, i) => (
                <React.Fragment key={i}>
                  <Route
                    key={el.id}
                    path={`/exercices-turism/excercie-${el.id}-options`}
                    element={getComponentElements("ExerciseOptions", el)}
                    init={init}
                    setInit={setInit}
                  />
                  <Route
                    key={el.id}
                    path={`/exercices/submenu${el.id}`}
                    element={getComponentElements("Submenu", el)}
                    init={init}
                    setInit={setInit}
                  />
                  {el.exercices.map((e, j) => (
                    <Route
                      key={`ex-${el.id}${j + 1}`}
                      path={`/exercices/submenu${el.id}/ex-${el.id}${j + 1}`}
                      element={getComponentElements(
                        "Ex" + e.type.charAt(0).toUpperCase() + e.type.slice(1),
                        e,
                        el.title
                      )}
                      init={init}
                      setInit={setInit}
                    />
                  ))}
                </React.Fragment>
              ))}
            <Route
              path="/uned-blog"
              element={
                <Iframe
                  page="https://blogs.uned.es/herramientasautocorreccionescrituraingles/"
                  setInit={setInit}
                />
              }
            />
            <Route exact path="/uned-contacto" element={privateRouteElement}>
              <Route
                path="/uned-contacto"
                element={
                  <ContactPage
                    init={init}
                    setInit={setInit}
                    loaded={loaded}
                    setLoaded={setLoaded}
                  />
                }
              />
            </Route>

            <Route exact path="/profile" element={privateRouteElement}>
              <Route
                path="/profile"
                element={
                  <ProfilePage
                    init={init}
                    setInit={setInit}
                    loaded={loaded}
                    setLoaded={setLoaded}
                  />
                }
              />
            </Route>
            <Route
              exact
              path="/exercices/category/"
              element={privateRouteElement}
            >
              <Route
                path="/exercices/category/"
                element={<ExerciseCatsPage init={init} setInit={setInit} />}
              />
            </Route>
            <Route
              exact
              path="/checker/category/"
              element={privateRouteElement}
            >
              <Route
                path="/checker/category/"
                element={
                  <ExerciseCatsPage
                    init={init}
                    setInit={setInit}
                    generalPath="/genre-writing-checker/general"
                    tourismPath="/genre-writing-checker/turism"
                    generalLabel="Autocorrige tu género textual general"
                    tourismLabel="Autocorrige tu género textual orientado a la industria turística"
                    iconVariant="autocorrection"
                  />
                }
              />
            </Route>
            <Route
              exact
              path="/genre-writing-checker/general"
              element={privateRouteElement}
            >
              <Route
                path="/genre-writing-checker/general"
                element={
                  <GenreCheckerDropdownPage
                    init={init}
                    setInit={setInit}
                    title={globalT("Géneros textuales generales")}
                    data={menu1Data}
                  />
                }
              />
            </Route>
            <Route
              exact
              path="/genre-writing-checker/turism"
              element={privateRouteElement}
            >
              <Route
                path="/genre-writing-checker/turism"
                element={
                  <GenreCheckerDropdownPage
                    init={init}
                    setInit={setInit}
                    title={globalT(
                      "Géneros textuales orientados a la industria turística"
                    )}
                    data={menu2Data}
                  />
                }
              />
            </Route>
            <Route exact path="/exercices" element={privateRouteElement}>
              <Route
                path="/exercices"
                element={
                  <ExsPage init={init} setInit={setInit} data={menu1Data} />
                }
              />
            </Route>
            <Route exact path="/exercices-turism" element={privateRouteElement}>
              <Route
                path="/exercices-turism"
                element={
                  <ExsPage init={init} setInit={setInit} data={menu2Data} />
                }
              />
            </Route>
            <Route exact path="/" element={privateRouteElement}>
              <Route
                path="/"
                element={<InitialPage init={init} setInit={setInit} />}
              />
            </Route>

            <Route exact path="/forgot-password" element={isLoggedRouteElement}>
              <Route
                path="/forgot-password"
                element={<SendForgotForm setInit={setInit} />}
              />
            </Route>

            <Route exact path="/reset-password" element={isLoggedRouteElement}>
              <Route
                path="/reset-password"
                element={<ForgotForm setInit={setInit} />}
              />
            </Route>

            <Route
              path="/tutorial/:tutorialId"
              element={<Iframe setInit={setInit} />}
            />
            <Route
              path="/texto-de-oro/:pdfId"
              element={<PdfViewer setInit={setInit} />}
            />
            <Route
              path="/pdf/:language/:pdfFileName"
              element={<LegacyPdfHashRoute />}
            />

            <Route path="*" element={<Error404 />} />
          </Routes>
        </div>
      </div>
    </RouterComponent>
  );
};

const ContentBackButton = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === "/") {
    return null;
  }

  return (
    <button
      className="m-back"
      type="button"
      onClick={() => {
        navigate(-1);
      }}
    >
      <ArrowL />
      <div>{globalT("Atrás")}</div>
    </button>
  );
};

const LegacyPdfHashRoute = () => {
  const { language, pdfFileName } = useParams();

  useEffect(() => {
    if (!language || !pdfFileName) {
      return;
    }

    window.location.replace(`/pdf/${language}/${pdfFileName}`);
  }, [language, pdfFileName]);

  return null;
};

const getComponentElements = (componentName, el, genre) => {
  const Component = componentsMap[componentName];
  if (Component && el) {
    return (
      <React.Fragment>
        <Component el={el} genre={genre} />
      </React.Fragment>
    );
  }
};

const isLocalEnvironment = () =>
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname);

const getStoredUser = () => {
  const user = localStorage.getItem("user");

  if (!user) {
    return null;
  }

  try {
    return JSON.parse(user);
  } catch {
    return null;
  }
};

const getLocalDevUser = () => {
  const storedUser = getStoredUser();

  if (storedUser) {
    return storedUser;
  }

  const localUser = {
    name: "Local",
    email: "local@rewrite.dev",
    userId: "local-dev",
    token: "local-dev",
    isLogged: true,
  };

  localStorage.setItem("user", JSON.stringify(localUser));

  return localUser;
};

//? Objeto con los componentes que vamos a tener en la web
const componentsMap = {
  Submenu,
  ExerciseOptions,
  ExDrag,
  ExAbc,
  ExMultipleabc,
  ExPopups,
  Ex1popup,
};
